import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserData, registerToApey } from "components/apiHandler/index";
import { loginRequest } from "config/authConfig";
import { msalInstance } from "index";

// Create an async thunk for fetching user data from Microsoft Graph API
export const fetchUserData = createAsyncThunk(
  "auth/fetchUserData",
  async (accessToken = null) => {
    try {
      const account = msalInstance.getActiveAccount();
      if (!accessToken) {
        if (!account) {
          return {
            response: null,
            accessToken: null,
            error: "No active account found. Please select an account.",
          };
        }
        let response = null;
        const lastLoginTime = parseInt(localStorage.getItem("lastLoginTime") || 0) || null;

        const currentTime = new Date().getTime();
        const eightHrs = 8 * 60 * 60 * 1000;
        if (!lastLoginTime || currentTime - lastLoginTime > eightHrs) {
          console.log("Login session expired. Redirecting for re-login...");
          await msalInstance.loginRedirect(loginRequest);
          return;
        }
        try {
          response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account,
          });
          const expirationTime = response.expiresOn.getTime();
          if (expirationTime - currentTime <= 5 * 60 * 1000) {
            response = await msalInstance.acquireTokenSilent({
              ...loginRequest,
              account,
              forceRefresh: true,
            });
          }
        } catch (error) {
          await msalInstance.acquireTokenRedirect(loginRequest);
        }
        accessToken = response?.accessToken;
        if (!accessToken) {
          console.error("Some error occured! Please try again.");
          return {
            response: null,
            accessToken: null,
            error: "Some error occured! Please try again.",
          };
        }
      }
      localStorage.setItem('lastLoginTime', new Date().getTime())
      const response = await getUserData({ accessToken, userId: account?.localAccountId });
      let formatResponse = {};


      if (Object.keys(response)?.length > 0) {
        Object.keys(response).forEach(key => {
          const fKey = key.replace(/^[^_]*_[^_]*_/, '');
          formatResponse[fKey] = response[key]
        })
      }

      return { response: formatResponse, accessToken, error: null };
    } catch (error) {
      // If there's an error, reject the promise with the error data
      return {
        response: null,
        accessToken: null,
        error,
      };
    }
  }
);

export const registerToBectran = createAsyncThunk("auth/registerToBectran", async (payload = {}) => {
  try {
    const response = await registerToApey(payload);
    return {
      error: null,
      response
    }
  } catch (error) {
    return {
      error,
      response: null
    }
  }
})